module.exports = __webpack_public_path__ + "static/img/boy.4bb0a397.svg";